import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=3bb0cbfe&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"
import style0 from "./productType.vue?vue&type=style&index=0&id=3bb0cbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0cbfe",
  null
  
)

export default component.exports